import { render, staticRenderFns } from "./EditAgent.vue?vue&type=template&id=19364a5a&scoped=true&"
import script from "./EditAgent.vue?vue&type=script&lang=js&"
export * from "./EditAgent.vue?vue&type=script&lang=js&"
import style0 from "./EditAgent.vue?vue&type=style&index=0&id=19364a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19364a5a",
  null
  
)

export default component.exports